import React, { useEffect } from "react";
import "./layout.css";
import Header from "../header/Header";
import { useSelector } from "react-redux";
import Sidebar from "../sidebar/Sidebar";
import { Outlet, useLocation } from "react-router-dom";
import {
  setMessAlert,
  setOpenAlert,
  setSidebarWidth,
} from "../../redux/slice/actionSlice";
import store from "../../redux/store";
import { Drawer } from "antd";
import Loader from "../Loader";
import SmallModal from "../modal/SmallModal";
import { Alerts } from "../Alerts/Alerts";

const Layout = React.memo(() => {
  const { smallSidebarWidth, open, mess, loading } = useSelector(
    (state) => state.actions
  );
  const { pathname } = useLocation();

  useEffect(() => {
    store.dispatch(setOpenAlert(false));
    store.dispatch(setMessAlert([]));
  }, [pathname]);

  return (
    <div className="layout-main">
      <div
        className="layout-sidebar"
        style={{
          width: smallSidebarWidth ? "4rem" : "20rem",
          transition: "width ease 1s",
        }}
      >
        <Sidebar />
      </div>
      <div className="sidebar-new">
        <Drawer
          width={"16rem"}
          placement={"left"}
          destroyOnClose={true}
          rootClassName={"sidebar-new"}
          Header={false}
          onClose={() => store.dispatch(setSidebarWidth(!smallSidebarWidth))}
          open={smallSidebarWidth}
        >
          <Sidebar />
        </Drawer>
      </div>

      <div className="layout-body">
        <div className="layout-header">
          <Header />
        </div>
        <div className="layout-outlet">
          <Outlet />
        </div>
      </div>
      {open && (
        <SmallModal
          title={"Alerts"}
          isOpen={open}
          setIsOpen={(value) => store.dispatch(setOpenAlert(value))}
          mess={Array.isArray(mess) ? <Alerts data={mess} /> : mess}
          okbtn={true}
        />
      )}
      {loading && <Loader />}
    </div>
  );
});

export default Layout;
